import { itemHasSerialTracking } from 'services/inventory';
import { Item } from 'services/items';

export const resolveValueParsing = (item: Item, value: string) => {
  if (!value) return null;
  if (itemHasSerialTracking(item)) return parseInt(value, 10);
  return parseFloat(value);
};
